import Cookies from 'js-cookie';
import { AuthAction, AuthActionTypes, AuthState } from './types';

const initialState: AuthState = {
  loadingResetPassRequest: false,

  loadingSignInRequest: false,

  isSignedIn: false,

  isLogout: false,

  isCreateAddress: false,

  isLoginInGoogle: false,

  error: false,

  loading: false,

  forgotPasswordReq: false,

  forgotPasswordOk: false,

  resetPasswordReq: false,

  resetPasswordOk: false,

  passwordMessage: '',

  agreement: false,

  agreements: {
    id: '',

    content: '',
  },

  user: {
    data: {
      first_name: '',
      avatar: '',
    }
  },

  userCreate: {},

  emailExists: false,
};

export default function auth(
  state = initialState,

  action: AuthAction,
): AuthState {
  switch (action.type) {
    case AuthActionTypes.SIGN_IN_REQUEST:
      return {
        ...state,

        error: false,

        message: '',

        loadingSignInRequest: true,
      };

    case AuthActionTypes.SIGN_IN_SUCCESS:
      Cookies.set('@ConectoVarejo:user', JSON.stringify({
        data: action.payload.user.data
      })); // Armazenando o usuário no Cookie
      return {
        ...state,

        error: false,

        message: '',

        loadingSignInRequest: false,

        isSignedIn: true,

        agreement: action.payload.agreement,

        user: {
          ...state.user,

          ...action.payload.user,
        },
      };

    case AuthActionTypes.SIGN_IN_FAILURE:
      return {
        ...state,

        error: true,

        message: action.payload.messageError,

        loadingSignInRequest: false,

        loading: false,
      };

    case AuthActionTypes.SIGN_IN_SOCIAL_REQUEST:
      return {
        ...state,

        loadingSignInRequest: true,

        isLoginInGoogle: false,
      };

    case AuthActionTypes.SIGN_IN_SOCIAL_SUCCESS:
      return {
        ...state,

        loadingSignInRequest: false,

        isLoginInGoogle: true,

        isSignedIn: true,

        agreement: action.payload.agreement,

        user: action.payload.user,
      };

    case AuthActionTypes.SIGNOUT_REQUEST_SUCESS:
      Cookies.remove('@ConectoVarejo:user'); // Removendo o usuário dos Cookies

      return {
        ...initialState,
        isLogout: true,
      };

    case AuthActionTypes.RESET_LOGOUT:

    return {
      ...state,
      isLogout: false,
    }

    case AuthActionTypes.PAYMENT_REQUEST:
      return {
        ...state,

        loadingSignInRequest: true,

        error: true,

        isSignedIn: false,
      };

    case AuthActionTypes.ADDRESS_REQUEST:
      return {
        ...state,
        error: false,
      };

    case AuthActionTypes.ADDRESS_SUCCESS:
      // konsole.log(

      //   'AuthActionTypes.ADDRESS_SUCCESS:',

      //   action.payload.address_id,

      // );

      if (state.user.addresses) {
        state.user.addresses.forEach(address => {
          if (address.id.toString() === action.payload.address_id) {
            address.selected = 1;
          } else {
            address.selected = 0;
          }

          if (!address.reference) {
            address.reference = '';
          }
        });
      }

      return {
        ...state,

        user: {
          ...state.user,

          addresses: state.user.addresses,
        },

        error: false,
      };

    case AuthActionTypes.CARD_ESITEF_REQUEST:
      return {
        ...state,

        error: true,
      };

    case AuthActionTypes.CARD_LIST_REQUEST:
      return {
        ...state,

        error: true,
      };

    case AuthActionTypes.CARD_LIST_SUCCESS:
      //konsole.log('AuthActionTypes.CARD_LIST_SUCCESS:', action.payload.card);

      return {
        ...state,

        user: { ...state.user, methods: action.payload.card },

        error: true,
      };

    case AuthActionTypes.CARD_ESITEF_SUCCESS:
      //konsole.log('AuthActionTypes.CARD_ESITEF_SUCCESS:', action.payload.card);

      return {
        ...state,

        user: { ...state.user, methods: action.payload.card },

        error: false,
      };

    case AuthActionTypes.CARD_ESITEF_ERROR:
      //konsole.log('AuthActionTypes.CARD_ESITEF_SUCCESS:', action.payload.card);

      return {
        ...state,

        user: { ...state.user, methods: [] },

        error: false,

        loading: false,
      };

    case AuthActionTypes.CUSTOMER_CLEAR:
      //konsole.log('AuthActionTypes.CUSTOMER_CLEAR: ');

      return {
        ...state,

        error: false,

        step: undefined,

        message: '',
      };

    case AuthActionTypes.CUSTOMER_CREATE_REQUEST:
      //konsole.log('AuthActionTypes.CUSTOMER_CREATE_REQUEST: ');

      return {
        ...state,

        error: false,

        step: undefined,

        loading: true,

        message: '',
      };

    case AuthActionTypes.CUSTOMER_IS_EXIST:
      // konsole.log(

      //   'AuthActionTypes.CUSTOMER_IS_EXIST: ',

      //   action.payload.message,

      // );

      return {
        ...state,

        error: true,

        step: undefined,

        message: action.payload.message,

        loading: false,
      };

    case AuthActionTypes.CUSTOMER_CREATE_SUCCESS:
      const dataUser = action.payload.customer.data !== undefined
              ? {
                ...action.payload.customer.data,
                verified: action.payload.customer.data.is_verified
              }
              : action.payload.customer;
      Cookies.set('@ConectoVarejo:user', JSON.stringify({
        data: dataUser,
      }));

      return {
        ...state,

        mailConfirm: false,

        error: false,

        step: action.payload.step ? action.payload.step : state.step,

        message: '',

        user: {
          data: dataUser,   
        },

        loading: false,

        agreement: true,

        isSignedIn: true,
      };

    case AuthActionTypes.CUSTOMER_SET_STEP:
      //konsole.log('AuthActionTypes.CUSTOMER_SET_STEP: ');

      return {
        ...state,

        error: false,

        step: action.payload.step,

        message: '',
      };

    case AuthActionTypes.CUSTOMER_CONFIRM_MAIL:
      //konsole.log('AuthActionTypes.CUSTOMER_CONFIRM_MAIL: ');

      return {
        ...state,

        mailConfirm: false,
      };

    case AuthActionTypes.CUSTOMER_CONFIRM_MAIL_SUCCESS:
      //konsole.log('AuthActionTypes.CUSTOMER_CONFIRM_MAIL_SUCCESS: ');
      const data = {
            ...state.user.data,
            verified: 1,
        }
      Cookies.set('@ConectoVarejo:user', JSON.stringify({
        data,
      }));

      return {
        ...state,

        user: {
          ...state.user,

          data,
        },

        mailConfirm: true,

        isSignedIn: true,
      };

    case AuthActionTypes.CUSTOMER_CEP_REQUEST:
      return {
        ...state,

        address: undefined,

        loading: true,
      };

    case AuthActionTypes.CUSTOMER_CEP_CLEAR:
      return {
        ...state,

        address: undefined,

        loading: false,
      };

    case AuthActionTypes.ADDRESS_REMOVED_REQUEST:
      return {
        ...state,

        loading: true,
      };

    case AuthActionTypes.ADDRESS_REMOVED_SUCCESS:
      return {
        ...state,

        loading: false,
      };

    case AuthActionTypes.CUSTOMER_CEP_SUCCESS:
      //konsole.log('AuthActionTypes.CUSTOMER_CEP_SUCCESS: ', action.payload.address);

      return {
        ...state,

        address: action.payload.address,

        loading: false,
      };

    case AuthActionTypes.CUSTOMER_GET_ADDRESS_SUCCESS:
      return {
        ...state,

        user: {
          ...state.user,

          addresses: action.payload.address,
        },

        error: false,
      };

    case AuthActionTypes.CUSTOMER_CREATE_ADDRESS_REQUEST:
      return {
        ...state,

        error: false,

        loading: true,

        isCreateAddress: true,
      };

    case AuthActionTypes.CUSTOMER_CREATE_ADDRESS_SUCCESS:
      if (state.user.addresses) {
        if (
          action.payload.address.reference &&
          action.payload.address.reference === null
        ) {
          action.payload.address.reference = '';
        }

        state.user.addresses.push(action.payload.address);
      }

      return {
        ...state,

        user: {
          ...state.user,

          addresses: state.user.addresses,
        },

        address: undefined,

        error: false,

        loading: false,

        isCreateAddress: false,
      };

    case AuthActionTypes.CUSTOMER_FORGOT_PASS:
      return {
        ...state,

        forgotPasswordReq: true,
      };

    case AuthActionTypes.CUSTOMER_FORGOT_PASS_SUCCESS:
      //konsole.log(`CUSTOMER_FORGOT_PASS_SUCCESS ${action.payload.message}`);

      return {
        ...state,

        forgotPasswordReq: false,

        forgotPasswordOk: true,

        passwordMessage: action.payload.message,
      };

    case AuthActionTypes.CUSTOMER_FORGOT_PASS_CLEAR:
      return {
        ...state,

        forgotPasswordOk: false,

        forgotPasswordReq: false,

        passwordMessage: '',
      };

    case AuthActionTypes.CUSTOMER_FAVORITE_SAVE:
      return {
        ...state,

        loading: true,
      };

    case AuthActionTypes.CUSTOMER_FAVORITE_REMOVE: {
      //konsole.log('filteredFavoritesRow: ', action.payload.favorite.id, state.user.favorite);

      const filteredFavoritesRow = state.user.favorite?.filter(
        item => item.id !== action.payload.favorite.id,
      );

      //konsole.log('filteredFavoritesRow: ', filteredFavoritesRow);

      return {
        ...state,

        loading: false,

        user: {
          ...state.user,

          favorite: filteredFavoritesRow,
        },
      };
    }

    case AuthActionTypes.CUSTOMER_FAVORITE_SAVE_SUCCESS:
      if (state.user.favorite) {
        state.user.favorite.push(action.payload.favorite);
      }

      return {
        ...state,

        loading: false,

        user: {
          ...state.user,

          favorite: state.user.favorite,
        },
      };

    case AuthActionTypes.CUSTOMER_FAVORITE_LIST:
      return {
        ...state,

        loading: true,
      };

    case AuthActionTypes.CUSTOMER_FAVORITE_LIST_SUCCESS:
      return {
        ...state,

        loading: false,

        user: {
          ...state.user,

          favorite: action.payload.favorites,
        },
      };

    case AuthActionTypes.CUSTOMER_AGREEMENT_REQUEST:
      return {
        ...state,

        loading: true,
      };

    case AuthActionTypes.CUSTOMER_AGREEMENT_REQUEST_SUCCESS:
      return {
        ...state,

        agreements: action.payload.agreement,

        loading: false,
      };

    case AuthActionTypes.CUSTOMER_AGREEMENT_ACCEPTED:
      return {
        ...state,

        loading: false,
      };

    case AuthActionTypes.CUSTOMER_AGREEMENT_ACCEPTED_SUCCESS:
      return {
        ...state,

        agreement: true,

        loading: false,
      };

    case AuthActionTypes.CUSTOMER_UPDATE_REQUEST:
      return {
        ...state,

        loading: true,
      };

    case AuthActionTypes.CUSTOMER_UPDATE_SUCCESS:
      const user = {
          ...state.user,

          data: action.payload.customer,
        };
      Cookies.set('@ConectoVarejo:user', JSON.stringify({
        data: action.payload.customer
      }));
      return {
        ...state,

        loading: false,

        user,
      };

    case AuthActionTypes.CUSTOMER_UPDATE_METHODS_SUCCESS:
      return {
        ...state,

        user: {
          ...state.user,

          methods: action.payload.methods,
        },
      };

    case AuthActionTypes.CUSTOMER_UPDATE_ADDRESS_SUCCESS:
      return {
        ...state,

        user: {
          ...state.user,

          addresses: action.payload.address,
        },
      };

    case AuthActionTypes.CUSTOMER_UPDATE_FAILURE:
      return {
        ...state,

        loading: false,

        error: true,
      };

    case AuthActionTypes.CLEAR_MESSAGE:
      return {
        ...state,

        message: '',
      };

    case AuthActionTypes.CLEAR_LOADING:
      return {
        ...state,

        loading: false,
      };

    case AuthActionTypes.VERIFY_EMAIL_EXIST:
      return {
        ...state,

        loading: true,
      };

    case AuthActionTypes.VERIFY_EMAIL_EXIST_SUCCESS:
      return {
        ...state,

        loading: false,

        emailExists: true,
      };

    case AuthActionTypes.VERIFY_EMAIL_EXIST_ERROR:
      return {
        ...state,

        loading: false,

        emailExists: false,
      };

    case AuthActionTypes.VERIFY_CUSTOMER_IS_EXIST:
      return {
        ...state,

        loading: true,
      };

    case AuthActionTypes.VERIFY_CUSTOMER_IS_EXIST_SUCESS:
      return {
        ...state,

        loading: false,

        userCreate: action.payload.userCreate,

        step: action.payload.step,
      };

    case AuthActionTypes.UPDATE_CUSTOMER_CREATE:
      return {
        ...state,

        userCreate: {
          ...state.userCreate,

          ...action.payload.userCreate,
        },

        step: action.payload.step,
      };

    case AuthActionTypes.REMOVE_ACCOUNT_CUSTOMER:
      return {
        ...state,

        loading: true,
      };

    default:
      return state;
  }
}
